import React from "react";
import * as FiIcons from "react-icons/fi";

// Helper function to properly render react-icons with TypeScript
export const renderIcon = (IconComponent: any, props?: any) => {
  return React.createElement(IconComponent, props);
};

// Export commonly used icons with proper typing
export const Icon = {
  Plus: (props: any) => renderIcon(FiIcons.FiPlus, props),
  Edit2: (props: any) => renderIcon(FiIcons.FiEdit2, props),
  Trash2: (props: any) => renderIcon(FiIcons.FiTrash2, props),
  Search: (props: any) => renderIcon(FiIcons.FiSearch, props),
  Filter: (props: any) => renderIcon(FiIcons.FiFilter, props),
  Download: (props: any) => renderIcon(FiIcons.FiDownload, props),
  Link: (props: any) => renderIcon(FiIcons.FiLink, props),
  FileText: (props: any) => renderIcon(FiIcons.FiFileText, props),
  Video: (props: any) => renderIcon(FiIcons.FiVideo, props),
  Upload: (props: any) => renderIcon(FiIcons.FiUpload, props),
  Save: (props: any) => renderIcon(FiIcons.FiSave, props),
  Folder: (props: any) => renderIcon(FiIcons.FiFolder, props),
  Inbox: (props: any) => renderIcon(FiIcons.FiInbox, props),
  Book: (props: any) => renderIcon(FiIcons.FiBook, props),
  CheckCircle: (props: any) => renderIcon(FiIcons.FiCheckCircle, props),
  X: (props: any) => renderIcon(FiIcons.FiX, props),
  MoreVertical: (props: any) => renderIcon(FiIcons.FiMoreVertical, props),
  RefreshCw: (props: any) => renderIcon(FiIcons.FiRefreshCw, props),
  ArrowDown: (props: any) => renderIcon(FiIcons.FiArrowDown, props),
  Layers: (props: any) => renderIcon(FiIcons.FiLayers, props),
  Package: (props: any) => renderIcon(FiIcons.FiPackage, props),
  ChevronUp: (props: any) => renderIcon(FiIcons.FiChevronUp, props),
  ChevronDown: (props: any) => renderIcon(FiIcons.FiChevronDown, props),
  ChevronRight: (props: any) => renderIcon(FiIcons.FiChevronRight, props),
  Settings: (props: any) => renderIcon(FiIcons.FiSettings, props),
  ExternalLink: (props: any) => renderIcon(FiIcons.FiExternalLink, props),
  Eye: (props: any) => renderIcon(FiIcons.FiEye, props),
  Send: (props: any) => renderIcon(FiIcons.FiSend, props),
  ArrowLeft: (props: any) => renderIcon(FiIcons.FiArrowLeft, props),
  Zap: (props: any) => renderIcon(FiIcons.FiZap, props),
  AlertCircle: (props: any) => renderIcon(FiIcons.FiAlertCircle, props),
  Star: (props: any) => renderIcon(FiIcons.FiStar, props),
  Info: (props: any) => renderIcon(FiIcons.FiInfo, props),
  Calendar: (props: any) => renderIcon(FiIcons.FiCalendar, props),
  DollarSign: (props: any) => renderIcon(FiIcons.FiDollarSign, props),
  MapPin: (props: any) => renderIcon(FiIcons.FiMapPin, props),
  MessageSquare: (props: any) => renderIcon(FiIcons.FiMessageSquare, props),
};
